import React from 'react';
import PropTypes from 'prop-types';
import DoorImageContainer from './DoorImageContainer';
import DoorDialogContainer from './DoorDialogContainer';
import { formSchemaPropType } from '../../formSchema';

export default class Door extends React.Component {
  render() {
    const {
      number,
      data,
      top,
      left,
      backgroundImg,
      backgroundColor,
      borderColor,
      textColor,
      doorSize,
      dialogShown,
      doorClickAction,
      doorCloseClickAction,
      hasQuiz,
      showAnswer,
      collectUserData,
      formSchema,
      entryUrl,
      successDisplayed,
      successMsg,
      successType,
      existingEntryDisplayed,
      existingEntryMsg,
      existingEntryType,
      imageType,
      internalPreview,
      backendPreview,
      isMobile,
      emailFieldMsg,
      emptyFieldMsg,
      wrongDoor,
      wrongDoorContent,
      dataQueryHeadline,
    } = this.props;
    let convertHex = (hex) =>  {
      hex = String(hex);
      hex = hex.replace('#','');
      let r = parseInt(hex.substring(0,2), 16);
      let g = parseInt(hex.substring(2,4), 16);
      let b = parseInt(hex.substring(4,6), 16);
      let o =  Math.round(parseInt(hex.substring(6,8), 16) / 255 * 100) / 100;
      let result = 'rgba('+r+','+g+','+b+','+o+')';
      return result;
    }
    let backcolor = {backgroundColor};
    backcolor = convertHex(backcolor.backgroundColor);
    let bColor = {borderColor};
    bColor = convertHex(bColor.borderColor);
    return (
      <>
        <DoorImageContainer
          number={number}
          backgroundImg={backgroundImg}
          imageType={imageType}
          backgroundColor={backcolor}
          borderColor={bColor}
          textColor={textColor}
          top={top}
          left={left}
          isMobile={isMobile}
          doorSize={doorSize}
          doorClickAction={doorClickAction}
          data-number={number}
        />
        { !backendPreview && (
          <DoorDialogContainer
            number={number}
            internalPreview={internalPreview}
            dialogShown={dialogShown}
            data={data}
            doorCloseClickAction={doorCloseClickAction}
            collectUserData={collectUserData}
            hasQuiz={hasQuiz}
            showAnswer={showAnswer}
            formSchema={formSchema}
            entryUrl={entryUrl}
            successDisplayed={successDisplayed}
            successType={successType}
            successMsg={successMsg}
            existingEntryDisplayed={existingEntryDisplayed}
            existingEntryType={existingEntryType}
            existingEntryMsg={existingEntryMsg}
            emptyFieldMsg={emptyFieldMsg}
            emailFieldMsg={emailFieldMsg}
            wrongDoor={wrongDoor}
            wrongDoorContent={wrongDoorContent}
            dataQueryHeadline={dataQueryHeadline}
          />
        )}
      </>
    );
  }
}

Door.propTypes = {
  number: PropTypes.number.isRequired,
  data: PropTypes.shape().isRequired,
  top: PropTypes.number.isRequired,
  left: PropTypes.number.isRequired,
  backgroundImg: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  borderColor: PropTypes.string.isRequired,
  textColor: PropTypes.string.isRequired,
  doorSize: PropTypes.number,
  imageType: PropTypes.string.isRequired,
  dialogShown: PropTypes.bool,
  doorClickAction: PropTypes.func.isRequired,
  doorCloseClickAction: PropTypes.func.isRequired,
  hasQuiz: PropTypes.bool.isRequired,
  showAnswer: PropTypes.bool.isRequired,
  collectUserData: PropTypes.bool.isRequired,
  formSchema: PropTypes.objectOf(formSchemaPropType).isRequired,
  entryUrl: PropTypes.string.isRequired,
  successDisplayed: PropTypes.bool.isRequired,
  successType: PropTypes.string.isRequired,
  successMsg: PropTypes.string.isRequired,
  existingEntryDisplayed: PropTypes.bool.isRequired,
  existingEntryType: PropTypes.string.isRequired,
  existingEntryMsg: PropTypes.string.isRequired,
  internalPreview: PropTypes.bool.isRequired,
  backendPreview: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  emptyFieldMsg: PropTypes.string.isRequired,
  emailFieldMsg: PropTypes.string.isRequired,
  dataQueryHeadline: PropTypes.string.isRequired,
};

Door.defaultProps = {
  doorSize: 60,
  dialogShown: false,
};
